import { equal } from '@ember/object/computed';
import Enum from '@square/dashboard-utilities/utils/enum';
import ISO8601 from '@square/dashboard-data/models/squareup/bills/iso8601-date';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const EventType = new Enum(['UNKNOWN', 'CREATION', 'COMP', 'VOID', 'UNCOMP', 'DELETE', 'SPLIT']);

/**
 * This implements the squareup.bills.Itemization.Event proto:
 * https://prototype.sqprod.co/#/docs/squareup.bills.Itemization.Event
 */
export const Event = ProtoBaseModel.extend({
  eventType: attr(EventType),
  reason: attr(String),
  // Reason entered by the merchant for the event. Required by COMP and VOID event types.
  createdAt: attr(ISO8601),
  isVoid: equal('eventType', EventType.VOID)
});